import { Files } from './file-picker';

export function fileId(file: File): string {
  return `×${fileName(file)}×${fileSize(file)}×${fileType(
    file,
  )}×`.toLowerCase();
}

export function fileName(file: File): string {
  return file.name;
}

export function fileSize(file: File): string {
  function bytesToSize(bytes: number): string {
    const KB = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 1) {
      return '1 Byte';
    }
    if (bytes === 0) {
      return '0 Byte';
    }
    const value = Math.floor(Math.log(bytes) / Math.log(KB));
    const int = parseInt(value + '', 10);
    return `${Math.round(bytes / Math.pow(KB, int))} ${sizes[int]}`;
  }
  return bytesToSize(file.size);
}

export function fileType(file: File | Blob): string {
  return file.type ?? '';
}

export function mergeFiles(currentList: Files, newList: Files): Files {
  return [
    ...currentList,
    ...newList.filter((newFile) =>
      currentList.every(
        (currentFile) => fileId(currentFile) !== fileId(newFile),
      ),
    ),
  ];
}

export function fileIsImage(file: File | Blob): boolean {
  return fileType(file).startsWith('image');
}
